exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-dad175c8] .van-icon-arrow-left {\n  color: #a5a5a5 !important;\n}\n", "", {"version":3,"sources":["/root/workspace/__flow_work/__flow_builds/4cb2f070-1cb1-48d6-9927-b52792e75f7e/workspace/xinnuo-portal-vue_4vTD/src/mobile/DataInfo.vue","/root/workspace/__flow_work/__flow_builds/4cb2f070-1cb1-48d6-9927-b52792e75f7e/workspace/xinnuo-portal-vue_4vTD/src/mobile/DataInfo.vue"],"names":[],"mappings":";AAsCA;EACE,0BAAA;CCrCD","file":"DataInfo.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/deep/ .van-icon-arrow-left {\n  color: #a5a5a5 !important;\n}\n"," /deep/ .van-icon-arrow-left {\n  color: #a5a5a5 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dad175c8","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/mobile/DataInfo.vue
// module id = SpJ3
// module chunks = 1